var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "userInfomation"
  }, [_c('div', {
    staticClass: "user"
  }, [_c('div', {
    on: {
      "click": function ($event) {
        _vm.visible = true;
      }
    }
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "src": require("../../../assets/icons/icon-user.svg"),
      "alt": ""
    }
  }), _c('p', {
    staticClass: "user-name"
  }, [_vm._v(" " + _vm._s(_vm.user.name) + " ")])]), _c('b-btn', {
    staticClass: "btn btn-text p-0 text-nowrap text-13 text-md-16 mr-0 ml-md-3 tutorial termsBtn",
    attrs: {
      "href": "/m3dhub/tutorial/Hub_Manual.pdf",
      "target": "_blank",
      "download": ""
    }
  }, [_vm._v("메뉴얼")])], 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.visible,
      expression: "visible"
    }],
    staticClass: "userDetail"
  }, [_c('h2', [_vm._v("내 계정")]), _c('div', {
    staticClass: "user"
  }, [_c('img', {
    staticClass: "userImg",
    attrs: {
      "src": require("../../../assets/icons/icon-user.svg")
    }
  }), _c('p', {
    staticClass: "user-name"
  }, [_vm._v(" " + _vm._s(_vm.user.name) + " ")])]), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("로그아웃")]), _c('button', {
    staticClass: "close",
    on: {
      "click": function ($event) {
        _vm.visible = false;
      }
    }
  }, [_vm._v("닫기")])])]);

}
var staticRenderFns = []

export { render, staticRenderFns }